module.exports = __webpack_public_path__ + "img/abstract-banner-offline.b9993fb9.svg";